import { render, staticRenderFns } from "./open-platform.vue?vue&type=template&id=30cc2885&scoped=true&"
import script from "./open-platform.vue?vue&type=script&lang=js&"
export * from "./open-platform.vue?vue&type=script&lang=js&"
import style0 from "./open-platform.vue?vue&type=style&index=0&id=30cc2885&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc2885",
  null
  
)

export default component.exports